import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { DetailAggregateBusinessData } from '../pages/useInventoryDashboardStore/types';
import { DetailAggregateBusinessDataFactory } from '../domains/factories/DetailAggregateBusinessDataFactory';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { InventoryAnalyticsDetailAggreageBusinessInfo } from '@/coreInfrastructureModule/axios/generated/inventoryManage';

/**
 * 在庫削減ダッシュボードの概要情報を取得する
 */
export class GetInventoryDashboardDetailAggBizUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫削減ダッシュボードの詳細情報取得
   * @param sortType - ソートタイプ
   * @param sortTarget - ソート対象
   * @param limit - 表示制限
   * @param offset - オフセット
   * @param filterItemInfo - フィルター情報
   * @returns - 在庫削減ダッシュボードの概要情報
   */
  public async execute(
    sortType?: string,
    sortTarget?: string,
    limit?: number,
    offset?: number,
    filterItemInfo?: FilterContentItem[]
  ): Promise<INetworkResult<[DetailAggregateBusinessData[], IPagingOptions], IError>> {
    const filterItem = filterItemInfo ? FilterService.convertFilterObject(filterItemInfo) : undefined;
    const networkResult = await this.repository.getInventoryAnalyticsDetailsAggregateBusiness(
      sortType,
      sortTarget,
      limit,
      offset,
      filterItem
    );

    switch (networkResult.status.type) {
      case 'success': {
        const result = networkResult.status.data;
        return {
          status: {
            type: 'success',
            data: [result.data.map((d) => DetailAggregateBusinessDataFactory.create(d)), result.pagingOptions],
          },
        };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
